import React from 'react';
import RichText from '../StringHtmlToReact';
import './styles.scss';
import WofButton from '../WofButton';
const OfficialRules: React.FC<any> = ({ text,backgroundImage,ctaText,ctaLink ,ctabaseColor,ctahoverColor}) => {
  return (
    <div className="legal Official_Rules" style={{ backgroundImage: `url(${backgroundImage})` }}>
     <div className="container">
      <div className="row">
        <div className="col-md-12">
          <RichText stringHtml={text} />
        </div>
        <div className={"text-center col-12"}>
         {ctaText ? <WofButton baseColor={ctabaseColor} hoverColor ={ctahoverColor} href={ctaLink}>{ctaText}</WofButton>:null}
        </div>
        
      </div>
      </div>
    </div>
  );
};

export default OfficialRules;
